import { ViewModel,View } from "binder"
import { IStaticValueProvider } from "src/formBuilder/formBuilder/templateEditor/propertiesPanel/editors/IStaticValueProvider";
import { FormBuilderComponent } from "src/formBuilder/structure/components";
import { FormBuilderElement, ChildAcceptableFormBuilderElement, IFormBuilderElementVisitor } from "src/formBuilder/structure/element";
import { ContentPropertyType, CustomPropertyType, IPropertyTypeVisitor, PropertyType, StringPropertyType } from "src/formBuilder/structure/propertyTypes/propetyTypes";
import  { DummyPlaceHolderView } from "./dummyPlaceHolder-view"
import { DummyTablePlaceHolderComponent, DummyTablePlaceHolderComponentElement } from "./dummyTablePlaceHolderComponent/dummyTablePlaceHolderComponent-viewModel";
import { TypeEditorViewModel } from "./typeEditor/typeEditor-viewModel";

export class DummyPlaceHolderComponent extends FormBuilderComponent{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.name = 'Dummy';
        this.canAcceptContent = true;
        this.canAcceptMultipleContent = false;
        
        // this.addProperty("Content","",new ContentPropertyType(this),null,true);
        this.addProperty("TemplateType","",new DummyPlaceHolderTypePropertyType(this),"Content",true);
        this.addProperty("AsPopupWidth","data-bcustom-width",new StringPropertyType(this),"",false);
        this.addProperty("AsPopupHeight","data-bcustom-height",new StringPropertyType(this),"",false);
    }
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    CreateInternal(parent:ViewModel):FormBuilderElement{
        let result = new DummyPlaceHolderElement(parent);

        return result;
    }
}

export class DummyPlaceHolderElement extends ChildAcceptableFormBuilderElement{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new DummyPlaceHolderView();
    }
    public getTypeId(): string {
        return "VM-D27FD7C5-3B55-4A0B-9ECA-D565606CEF04"
    }

    public set Content(v: FormBuilderElement) { this._Content = v; } public get Content(): FormBuilderElement { return this._Content;} private _Content: FormBuilderElement;
    public set AsPopupWidth(v: string) { this._AsPopupWidth = v; } public get AsPopupWidth(): string { return this._AsPopupWidth;} private _AsPopupWidth: string;
    public set AsPopupHeight(v: string) { this._AsPopupHeight = v; } public get AsPopupHeight(): string { return this._AsPopupHeight;} private _AsPopupHeight: string;
    
    public set TemplateType(v: string) { 
        let shallChange = true;
        if((this.TemplateType=='Combo' || this.TemplateType=='Content') && (v=='Combo' || v=='Content')){
            shallChange = false;
        }else if(this.TemplateType=='Table' && v=="Table"){
            shallChange = false;
        }
        this._TemplateType = v; 
        if(shallChange){
            if(this.TemplateType == 'Table'){
                this.removeChild(this.Content);
                let dummyTable = new DummyTablePlaceHolderComponent(this);
                let element = dummyTable.Create(this);
                this.addChild(element);
            }else if(this.TemplateType=='Combo' || this.TemplateType=='Content'){
                this.removeChild(this.Content);
            }
        }

        
    } public get TemplateType(): string { return this._TemplateType;} private _TemplateType: string;
    
    Accept(visitor: IFormBuilderElementVisitor, parameter: object): object {
        return visitor.VisitDummyPlaceHolder(this,parameter);
    }
    addChildInternal(element: FormBuilderElement): void {
        this.children.update(...[element]);
        this.Content = element;
    }
    removeChild(element: FormBuilderElement): void {
        if(element && this.Content &&this.Content.self == element.self){
            this.children.clear();
            this.Content = null;
        }
    }
    
}

export class DummyPlaceHolderTypePropertyType extends CustomPropertyType{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    getEditor(parent:ViewModel) : IStaticValueProvider{
        return new TypeEditorViewModel(parent);
    }
}

